import { render, staticRenderFns } from "./TextChat.vue?vue&type=template&id=5d17292e&scoped=true&"
import script from "./text-chat.js?vue&type=script&lang=js&"
export * from "./text-chat.js?vue&type=script&lang=js&"
import style0 from "./text-chat.scss?vue&type=style&index=0&id=5d17292e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17292e",
  null
  
)

export default component.exports